import styled from 'styled-components';

const Bold = styled.h3`
  font-family: Roboto, serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 35px;
  letter-spacing: 0;
  text-align: center;
`;

const Dimmer = styled.span`
  font-family: Roboto, serif;
  font-size: 16px;
  text-align: center;
  max-width: 330px;
  color: #00000080;
  margin: 8px 0 35px 0;
`;

const Blue = styled(Dimmer)`
  color: #2d9cdb;
`;

const Button = styled.button`
  background: #2d9cdb;
  height: 34px;
  width: 226px;
  border-radius: 4px;

  border: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;

  font-family: 'Roboto', serif;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #ffffff;
`;

export const S = {
  Bold,
  Dimmer,
  Blue,
  Button,
};
